export default "__VITE_ASSET__79c680ee__"